export enum WebviewTenant {
  ACKODRIVE = 'ACKODRIVE',
}
